/** Desktop open positions table — aligned with TradeDesktopContent / history footer tables. */

export { DESKTOP_HISTORY_TABLE_CLASS as OPEN_POSITIONS_TABLE_CLASS } from "@/components/history-view/content/historyDesktopTableLayout";
export {
  historyTh as openPositionsTh,
  historyTd as openPositionsTd,
} from "@/components/history-view/content/historyDesktopTableLayout";

export const OPEN_POSITION_COL_WIDTHS = {
  symbol: "w-24",
  direction: "w-20",
  lots: "w-16",
  ticket: "w-20",
  openPrice: "w-24",
  tp: "w-20",
  sl: "w-20",
  current: "w-24",
  change: "w-20",
  pnl: "w-20",
  actions: "w-16",
} as const;

export const OPEN_POSITIONS_COL_SPAN = 11;
